export const PRODUCT_STATUS_DATA = [
  {
    value: true,
    label: 'Show',
  },
  {
    value: false,
    label: 'Hide',
  },
];
